exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".LotStream-header-2kr7_{overflow:hidden}.LotStream-headerMain-205dl{float:left;padding-top:5px;line-height:36px}.LotStream-headerMain-205dl>a,.LotStream-headerMain-205dl>span{line-height:1;display:inline-block;vertical-align:bottom}.LotStream-headerSide-2wMfK{overflow:hidden;padding-top:5px;padding-right:5px}.LotStream-headerSide-2wMfK label{float:right;margin-left:20px}", ""]);

// exports
exports.locals = {
	"header": "LotStream-header-2kr7_",
	"headerMain": "LotStream-headerMain-205dl",
	"headerSide": "LotStream-headerSide-2wMfK"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/patrimony/components/LotStream.less
// module id = 1688
// module chunks = 0